// Interactive Landing Page JavaScript

document.addEventListener('DOMContentLoaded', function() {

    // Initialize all interactive components
    initBenefitHover();
    initComparisonTable();
    initProblemsSection();
    initDogBuilder();
    initInteractiveSteps();
    initReviewSlider();
    initFeatureModal();
    initScrollAnimations();

    // Benefit items hover effects
    function initBenefitHover() {
        const benefitItems = document.querySelectorAll('.benefit-item');

        benefitItems.forEach(item => {
            item.addEventListener('mouseenter', function() {
                const benefit = this.dataset.benefit;
                showBenefitTooltip(benefit, this);
            });

            item.addEventListener('mouseleave', function() {
                hideBenefitTooltip();
            });
        });
    }

    function showBenefitTooltip(benefit, element) {
        const tooltips = {
            custom: 'Tailored nutrition based on your dog\'s size, age, and activity level',
            trustworthy: '100% grass-fed beef and organic chicken from certified sources',
            ethical: 'Certified humane farming practices and sustainable sourcing'
        };

        // Create tooltip if it doesn't exist
        let tooltip = document.getElementById('benefit-tooltip');
        if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.id = 'benefit-tooltip';
            tooltip.className = 'benefit-tooltip';
            document.body.appendChild(tooltip);
        }

        tooltip.textContent = tooltips[benefit];
        tooltip.style.display = 'block';

        const rect = element.getBoundingClientRect();
        tooltip.style.left = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) + 'px';
        tooltip.style.top = rect.bottom + 10 + 'px';
    }

    function hideBenefitTooltip() {
        const tooltip = document.getElementById('benefit-tooltip');
        if (tooltip) {
            tooltip.style.display = 'none';
        }
    }

    // Interactive Comparison Table
    function initComparisonTable() {
        const toggleBtns = document.querySelectorAll('.toggle-btn');
        const comparisonViews = document.querySelectorAll('.comparison-view');
        const featureRows = document.querySelectorAll('.feature-row');

        // Toggle between feature and visual comparison
        toggleBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                const view = this.dataset.view;

                // Update active button
                toggleBtns.forEach(b => b.classList.remove('active'));
                this.classList.add('active');

                // Show corresponding view
                comparisonViews.forEach(v => v.classList.remove('active'));
                document.getElementById(view + '-view').classList.add('active');
            });
        });

        // Feature row interactions
        featureRows.forEach(row => {
            row.addEventListener('click', function() {
                const feature = this.dataset.feature;
                showFeatureDetails(feature);
            });

            row.addEventListener('mouseenter', function() {
                this.style.backgroundColor = 'rgba(76, 175, 80, 0.1)';
            });

            row.addEventListener('mouseleave', function() {
                this.style.backgroundColor = '';
            });
        });
    }

    function showFeatureDetails(feature) {
        const featureDetails = {
            beef: {
                title: '100% Grass-Fed Beef',
                content: 'Our grass-fed beef comes from cattle that graze on pasture their entire lives, resulting in higher omega-3 fatty acids and better taste for your dog.'
            },
            chicken: {
                title: 'Certified Organic Chicken',
                content: 'Our organic chicken is raised without antibiotics, hormones, or GMO feed, ensuring the purest protein for your pet.'
            },
            hormones: {
                title: 'No Antibiotics or Hormones',
                content: 'We never use antibiotics or added hormones in our meat, keeping your dog\'s food as natural and healthy as possible.'
            },
            treatment: {
                title: 'Certified Humane Treatment',
                content: 'All our animals are raised according to the highest welfare standards with access to pasture and humane treatment throughout their lives.'
            },
            cooking: {
                title: 'Slow-Cooked Process',
                content: 'We cook our food at low temperatures to preserve nutrients and create the most digestible, nutritious meal for your dog.'
            },
            expertise: {
                title: 'Meat Sourcing Expertise',
                content: 'With years of experience in premium meat sourcing, we know exactly where to find the highest quality ingredients for your pet.'
            }
        };

        const modal = document.getElementById('feature-modal');
        const modalBody = document.getElementById('modal-body');
        const details = featureDetails[feature];

        if (details && modal && modalBody) {
            modalBody.innerHTML = `
                <h3>${details.title}</h3>
                <p>${details.content}</p>
                <div style="text-align: center; margin-top: 20px;">
                    <a href="/pages/dog-quiz" class="button button--primary">Try It Now</a>
                </div>
            `;
            modal.style.display = 'block';
        }
    }

    // Problems Section
    function initProblemsSection() {
        const problemCards = document.querySelectorAll('.problem-card');

        problemCards.forEach(card => {
            card.addEventListener('click', function() {
                const isActive = this.classList.contains('active');

                // Close all cards first
                problemCards.forEach(c => {
                    c.classList.remove('active');
                    const desc = c.querySelector('.problem-description');
                    desc.classList.add('hidden');
                });

                // Open clicked card if it wasn't active
                if (!isActive) {
                    this.classList.add('active');
                    const description = this.querySelector('.problem-description');
                    description.classList.remove('hidden');
                }
            });
        });
    }

    // Dog Builder
    function initDogBuilder() {
        const sizeBtns = document.querySelectorAll('.size-btn');
        const dogImage = document.getElementById('dog-image');
        const callouts = document.querySelectorAll('.callout');

        const dogData = {
            small: {
                image: 'https://cdn.shopify.com/s/files/1/0686/6180/5346/files/small-dog.jpg',
                alt: 'Small dog',
                callouts: ['Gentle Digestion', 'Increased Energy', 'Healthy Weight']
            },
            medium: {
                image: 'https://cdn.shopify.com/s/files/1/0686/6180/5346/files/medium-dog.jpg',
                alt: 'Medium dog',
                callouts: ['Shinier Coat', 'More Energy', 'Better Digestion']
            },
            large: {
                image: 'https://cdn.shopify.com/s/files/1/0686/6180/5346/files/large-dog.jpg',
                alt: 'Large dog',
                callouts: ['Joint Health', 'Muscle Tone', 'Coat Shine']
            }
        };

        sizeBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                const size = this.dataset.size;

                // Update active button
                sizeBtns.forEach(b => b.classList.remove('active'));
                this.classList.add('active');

                // Update dog image and benefits
                if (dogImage && dogData[size]) {
                    dogImage.src = dogData[size].image;
                    dogImage.alt = dogData[size].alt;

                    // Update callout text
                    callouts.forEach((callout, index) => {
                        if (dogData[size].callouts[index]) {
                            callout.textContent = dogData[size].callouts[index];
                        }
                    });

                    // Trigger animation
                    dogImage.style.transform = 'scale(0.95)';
                    setTimeout(() => {
                        dogImage.style.transform = 'scale(1)';
                    }, 150);
                }
            });
        });

        // Callout interactions
        callouts.forEach(callout => {
            callout.addEventListener('click', function() {
                showBenefitDetail(this.textContent);
            });
        });
    }

    function showBenefitDetail(benefit) {
        const benefits = {
            'Shinier Coat': 'High-quality proteins and omega-3 fatty acids promote a lustrous, healthy coat.',
            'More Energy': 'Nutrient-dense ingredients provide sustained energy for active dogs.',
            'Better Digestion': 'Easily digestible proteins support optimal gut health.',
            'Gentle Digestion': 'Specially formulated for sensitive small dog stomachs.',
            'Increased Energy': 'Balanced nutrition supports active small breed lifestyles.',
            'Healthy Weight': 'Portion-controlled meals help maintain optimal weight.',
            'Joint Health': 'Essential nutrients support joint mobility in large breeds.',
            'Muscle Tone': 'High-quality protein builds and maintains lean muscle mass.',
            'Coat Shine': 'Premium ingredients create a beautiful, glossy coat.'
        };

        const description = benefits[benefit];
        if (description) {
            showToast(`${benefit}: ${description}`);
        }
    }

    // Interactive Steps
    function initInteractiveSteps() {
        const stepCircles = document.querySelectorAll('.step-circle');
        const stepPanels = document.querySelectorAll('.step-panel');
        const nextBtn = document.querySelector('.next-btn');
        const prevBtn = document.querySelector('.prev-btn');
        let currentStep = 1;
        let autoAdvanceInterval = null;
        let userInteracted = false;

        // Step circle navigation
        stepCircles.forEach(circle => {
            circle.addEventListener('click', function() {
                userInteracted = true;
                stopAutoAdvance();
                const step = parseInt(this.dataset.step);
                showStep(step);
            });

            // Add hover effect for step circles
            circle.addEventListener('mouseenter', function() {
                if (!this.classList.contains('active')) {
                    this.style.transform = 'scale(1.02)';
                }
            });

            circle.addEventListener('mouseleave', function() {
                if (!this.classList.contains('active')) {
                    this.style.transform = '';
                }
            });
        });

        // Next/Previous buttons
        if (nextBtn) {
            nextBtn.addEventListener('click', function() {
                userInteracted = true;
                stopAutoAdvance();
                if (currentStep < 3) {
                    showStep(currentStep + 1);
                }
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function() {
                userInteracted = true;
                stopAutoAdvance();
                if (currentStep > 1) {
                    showStep(currentStep - 1);
                }
            });
        }

        function showStep(step) {
            currentStep = step;

            // Update circles
            stepCircles.forEach(circle => {
                circle.classList.remove('active');
                if (parseInt(circle.dataset.step) === step) {
                    circle.classList.add('active');
                }
            });

            // Update panels
            stepPanels.forEach(panel => {
                panel.classList.remove('active');
                if (parseInt(panel.dataset.step) === step) {
                    panel.classList.add('active');
                }
            });

            // Update button states
            if (prevBtn) {
                prevBtn.disabled = step === 1;
            }
            if (nextBtn) {
                nextBtn.disabled = step === 3;
            }
        }

        function startAutoAdvance() {
            if (!userInteracted) {
                autoAdvanceInterval = setInterval(() => {
                    const nextStep = currentStep === 3 ? 1 : currentStep + 1;
                    showStep(nextStep);
                }, 5000);
            }
        }

        function stopAutoAdvance() {
            if (autoAdvanceInterval) {
                clearInterval(autoAdvanceInterval);
                autoAdvanceInterval = null;
            }
        }

        // Start auto-advance
        startAutoAdvance();
    }

    // Review Slider
    function initReviewSlider() {
        const slider = document.querySelector('.reviews-slider');
        if (!slider) return;

        // Add touch/mouse drag support for better mobile experience
        let isScrolling = false;
        let startX = 0;
        let scrollLeft = 0;

        // Mouse events for desktop
        slider.addEventListener('mousedown', (e) => {
            isScrolling = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            slider.style.cursor = 'grabbing';
        });

        slider.addEventListener('mouseleave', () => {
            isScrolling = false;
            slider.style.cursor = 'grab';
        });

        slider.addEventListener('mouseup', () => {
            isScrolling = false;
            slider.style.cursor = 'grab';
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isScrolling) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            slider.scrollLeft = scrollLeft - walk;
        });

        // Add grab cursor
        slider.style.cursor = 'grab';

        // Auto-scroll functionality (optional)
        let autoScrollInterval;

        const startAutoScroll = () => {
            autoScrollInterval = setInterval(() => {
                const maxScroll = slider.scrollWidth - slider.clientWidth;
                if (slider.scrollLeft >= maxScroll) {
                    slider.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    slider.scrollBy({ left: 320, behavior: 'smooth' });
                }
            }, 5000);
        };

        const stopAutoScroll = () => {
            if (autoScrollInterval) {
                clearInterval(autoScrollInterval);
            }
        };

        // Start auto-scroll on desktop only
        if (window.innerWidth >= 1024) {
            startAutoScroll();
        }

        // Stop auto-scroll when user interacts
        slider.addEventListener('mouseenter', stopAutoScroll);
        slider.addEventListener('touchstart', stopAutoScroll);
        slider.addEventListener('scroll', stopAutoScroll);

        // Resume auto-scroll after inactivity
        let inactivityTimer;
        const resetInactivityTimer = () => {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                if (window.innerWidth >= 1024) {
                    startAutoScroll();
                }
            }, 10000);
        };

        slider.addEventListener('mouseleave', resetInactivityTimer);
    }

    // Feature Modal
    function initFeatureModal() {
        const modal = document.getElementById('feature-modal');
        const closeBtn = modal?.querySelector('.close');

        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                modal.style.display = 'none';
            });
        }

        // Close modal when clicking outside
        window.addEventListener('click', function(event) {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
    }

    // Scroll Animations
    function initScrollAnimations() {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        // Observe elements for animation
        const animatedElements = document.querySelectorAll(
            '.quality-card, .problem-card, .review-card, .guarantee-feature, .press-quote'
        );

        animatedElements.forEach(el => {
            observer.observe(el);
        });
    }

    // Utility Functions
    function showToast(message) {
        // Create toast if it doesn't exist
        let toast = document.getElementById('toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.id = 'toast';
            toast.className = 'toast';
            document.body.appendChild(toast);
        }

        toast.textContent = message;
        toast.classList.add('show');

        setTimeout(() => {
            toast.classList.remove('show');
        }, 3000);
    }

    // Track interactions for analytics
    function trackInteraction(action, element) {
        // Example: Send to analytics
        if (typeof gtag !== 'undefined') {
            gtag('event', 'interaction', {
                'event_category': 'landing_page',
                'event_label': action,
                'value': element
            });
        }
    }

    // Add interaction tracking to key elements
    document.addEventListener('click', function(event) {
        const element = event.target;

        if (element.classList.contains('button--primary')) {
            trackInteraction('cta_click', element.textContent);
        }

        if (element.classList.contains('feature-row')) {
            trackInteraction('feature_click', element.dataset.feature);
        }

        if (element.classList.contains('problem-card')) {
            trackInteraction('problem_click', element.dataset.problem);
        }
    });
});

// Add CSS for toast and tooltip
const style = document.createElement('style');
style.textContent = `
    .benefit-tooltip {
        position: absolute;
        background: rgba(57, 56, 60, 0.9);
        color: white;
        padding: 10px 15px;
        border-radius: 8px;
        font-size: 14px;
        max-width: 200px;
        text-align: center;
        z-index: 1000;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        display: none;
    }

    .benefit-tooltip::before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-bottom-color: rgba(57, 56, 60, 0.9);
    }

    .toast {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 15px 25px;
        border-radius: 25px;
        font-weight: 600;
        z-index: 1000;
        transform: translateY(100px);
        opacity: 0;
        transition: all 0.3s ease;
        max-width: 300px;
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }

    .toast.show {
        transform: translateY(0);
        opacity: 1;
    }

    .animate-in {
        animation: fadeInUp 0.8s ease forwards;
    }
`;

document.head.appendChild(style);